import { IAssignment } from "@/api/assignments/types";
import { useGetTaskAssignments } from "@/features/assignments/hooks/useGetTaskAssignments";
import { useGetAllUsers } from "@/features/users/hooks/useGetAllUsers";
import { IUsersData } from "@/features/users/slices/usersSlice";

interface UseAssignedUsersProps {
  taskId: string;
}

export interface IUserWithAssignment extends IUsersData {
  assignmentId: string;
}

export const useAssignedUsers = ({ taskId }: UseAssignedUsersProps) => {
  const activeUsers = 1;
  const { data: taskAssignments, isLoading: isLoadingTaskAssignments, refetch: refetchTaskAssignments } = useGetTaskAssignments(taskId);
  const { data: usersData, isLoading: isLoadingUsers } = useGetAllUsers(activeUsers);
  const users = usersData?.data;
  const taskAssignmentsData = taskAssignments?.data;

  // Lógica para determinar los usuarios asignados
  const userAssigned: IUserWithAssignment[] = (users && taskAssignmentsData)
    ? users.map((user: IUsersData) => {
      const assignment = taskAssignmentsData.find((assignment: IAssignment) =>
        assignment.username === user.username && assignment.taskId === taskId
      );
      return assignment ? { ...user, assignmentId: assignment.id } : { ...user, assignmentId: null };
    }).filter((user: IUserWithAssignment) => user.assignmentId !== null)
    : []; // Devuelve un array vacío si los datos aún no están disponibles

  const isLoading = isLoadingTaskAssignments || isLoadingUsers;

  return {
    userAssigned,
    isLoading,
    refetchTaskAssignments,
  };
};